var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const ATTENDANCE_API = 'api/attendance';
export const getHistory = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            let queryParams = '';
            if (params.userId)
                queryParams += `userId=${params.userId}&`; // ✅ AÑADIDO
            if (params.storeId)
                queryParams += `storeId=${params.storeId}&`;
            if (params.startDate)
                queryParams += `startDate=${params.startDate}&`;
            if (params.endDate)
                queryParams += `endDate=${params.endDate}&`;
            if (params.pageNum)
                queryParams += `pageNum=${params.pageNum}&`;
            if (params.limit)
                queryParams += `limit=${params.limit}&`;
            // Remove trailing '&'
            queryParams = queryParams.slice(0, -1);
            const url = queryParams ? `${ATTENDANCE_API}/history?${queryParams}` : `${ATTENDANCE_API}/history`;
            return yield this.axiosInstance.get(url, config);
        }
        catch (error) {
            console.error('Error fetching attendance history:', error);
            throw error;
        }
    });
};
export const getStatus = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            let queryParams = '';
            if (params === null || params === void 0 ? void 0 : params.storeId)
                queryParams += `storeId=${params.storeId}&`;
            if (params === null || params === void 0 ? void 0 : params.userId)
                queryParams += `userId=${params.userId}&`; // ✅ ARREGLADO - añadir &
            // Remove trailing '&'
            queryParams = queryParams.slice(0, -1);
            const url = queryParams ? `${ATTENDANCE_API}/status?${queryParams}` : `${ATTENDANCE_API}/status`;
            return yield this.axiosInstance.get(url, config);
        }
        catch (error) {
            console.error('Error fetching attendance status:', error);
            throw error;
        }
    });
};
export const getStoreReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            let queryParams = '';
            if (params === null || params === void 0 ? void 0 : params.startDate)
                queryParams += `startDate=${params.startDate}&`;
            if (params === null || params === void 0 ? void 0 : params.endDate)
                queryParams += `endDate=${params.endDate}&`;
            if (params === null || params === void 0 ? void 0 : params.employeeId)
                queryParams += `employeeId=${params.employeeId}&`;
            if (params === null || params === void 0 ? void 0 : params.pageNum)
                queryParams += `pageNum=${params.pageNum}&`;
            if (params === null || params === void 0 ? void 0 : params.limit)
                queryParams += `limit=${params.limit}&`;
            // Remove trailing '&'
            queryParams = queryParams.slice(0, -1);
            const url = queryParams ? `${ATTENDANCE_API}/store/${storeId}/report?${queryParams}` : `${ATTENDANCE_API}/store/${storeId}/report`;
            return yield this.axiosInstance.get(url, config);
        }
        catch (error) {
            console.error('Error fetching store attendance report:', error);
            throw error;
        }
    });
};
export const exportStoreReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            let queryParams = '';
            if (params === null || params === void 0 ? void 0 : params.startDate)
                queryParams += `startDate=${params.startDate}&`;
            if (params === null || params === void 0 ? void 0 : params.endDate)
                queryParams += `endDate=${params.endDate}&`;
            if (params === null || params === void 0 ? void 0 : params.employeeId)
                queryParams += `employeeId=${params.employeeId}&`;
            // Remove trailing '&'
            queryParams = queryParams.slice(0, -1);
            const url = queryParams ? `${ATTENDANCE_API}/store/${storeId}/report/export?${queryParams}` : `${ATTENDANCE_API}/store/${storeId}/report/export`;
            return yield this.axiosInstance.get(url, config);
        }
        catch (error) {
            console.error('Error exporting store attendance report:', error);
            throw error;
        }
    });
};
